export const START_NOTIFICATION_TRACKING = 'START_NOTIFICATION_TRACKING'
export const STOP_NOTIFICATION_TRACKING = 'STOP_NOTIFICATION_TRACKING'
export const RECEIVED_NOTIFICATION = 'RECEIVED_NOTIFICATION'
